import type * as CANNON from 'cannon-es'

/** 同心双底盘逆向旋转 */
export class MixerController {
  private targetOmega = 0
  private currentOmega = 0
  private boostUntil = 0
  private boostMul = 1

  constructor(
    private readonly diskInner: CANNON.Body,
    private readonly diskOuter: CANNON.Body,
  ) {}

  setTargetOmega(omega: number): void {
    this.targetOmega = Math.abs(omega)
  }

  boost(multiplier: number, durationSec: number, now: number): void {
    this.boostMul = multiplier
    this.boostUntil = now + durationSec
  }

  getOmega(): number {
    return this.currentOmega
  }

  update(dt: number, now: number): void {
    if (now > this.boostUntil) this.boostMul = 1
    const desired = this.targetOmega * this.boostMul
    const accel = 12
    if (this.currentOmega < desired) {
      this.currentOmega = Math.min(desired, this.currentOmega + accel * dt)
    } else if (this.currentOmega > desired) {
      this.currentOmega = Math.max(desired, this.currentOmega - accel * dt)
    }

    this.diskInner.velocity.set(0, 0, 0)
    this.diskOuter.velocity.set(0, 0, 0)
    // 内盘正转、外盘反转
    this.diskInner.angularVelocity.set(0, this.currentOmega, 0)
    this.diskOuter.angularVelocity.set(0, -this.currentOmega, 0)
  }

  stopImmediate(): void {
    this.targetOmega = 0
    this.currentOmega = 0
    this.boostMul = 1
    this.diskInner.angularVelocity.set(0, 0, 0)
    this.diskOuter.angularVelocity.set(0, 0, 0)
  }
}
